"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Email = exports.EmailStatusEnum = void 0;
const typeorm_1 = require("typeorm");
const accounting_documents_1 = require("./accounting-documents");
const contact_1 = require("./contact");
const email_attachment_1 = require("./email-attachment");
const job_1 = require("./job");
const data_ui_1 = require("../data-ui");
const layouts_1 = require("../data-ui/layouts");
const contact_profile_enum_1 = require("./contact-profile-enum");
var EmailStatusEnum;
(function (EmailStatusEnum) {
    EmailStatusEnum["PENDING"] = "pending";
    EmailStatusEnum["SENT"] = "sent";
    EmailStatusEnum["FAILED"] = "failed";
})(EmailStatusEnum = exports.EmailStatusEnum || (exports.EmailStatusEnum = {}));
let Email = class Email {
};
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
        name: 'id',
    }),
    __metadata("design:type", String)
], Email.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        nullable: true,
    }),
    (0, typeorm_1.Index)(),
    __metadata("design:type", String)
], Email.prototype, "messageId", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    (0, typeorm_1.Column)({
        type: 'text',
    }),
    __metadata("design:type", String)
], Email.prototype, "from", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    (0, typeorm_1.Column)({
        type: 'text',
        nullable: true,
    }),
    __metadata("design:type", String)
], Email.prototype, "replyTo", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        type: 'text',
        array: true,
    }),
    __metadata("design:type", Array)
], Email.prototype, "to", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        array: true,
        nullable: true,
        default: () => "'{}'",
    }),
    __metadata("design:type", Array)
], Email.prototype, "cc", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        array: true,
        nullable: true,
        default: () => "'{}'",
    }),
    __metadata("design:type", Array)
], Email.prototype, "bcc", void 0);
__decorate([
    (0, typeorm_1.Index)('idx_trgm_email_subject', { synchronize: false }),
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        type: 'text',
    }),
    __metadata("design:type", String)
], Email.prototype, "subject", void 0);
__decorate([
    data_ui_1.DataUi.Override({ mimeType: 'text/html' }),
    (0, typeorm_1.Column)({
        type: 'text',
    }),
    __metadata("design:type", String)
], Email.prototype, "bodyHtml", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        nullable: true,
    }),
    __metadata("design:type", String)
], Email.prototype, "bodyText", void 0);
__decorate([
    (0, typeorm_1.Index)('idx_trgm_email_template', { synchronize: false }),
    (0, typeorm_1.Column)({
        type: 'text',
    }),
    __metadata("design:type", String)
], Email.prototype, "template", void 0);
__decorate([
    (0, typeorm_1.Column)('jsonb', {
        nullable: true,
    }),
    __metadata("design:type", Object)
], Email.prototype, "metadata", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: EmailStatusEnum,
    }),
    __metadata("design:type", String)
], Email.prototype, "status", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        nullable: true,
    }),
    __metadata("design:type", String)
], Email.prototype, "deliveryStatus", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.CreateDateColumn)(),
    __metadata("design:type", Date)
], Email.prototype, "timestamp", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => email_attachment_1.EmailAttachment, (a) => a.email, {
        cascade: true,
    }),
    __metadata("design:type", Array)
], Email.prototype, "attachments", void 0);
__decorate([
    (0, typeorm_1.ManyToMany)(() => job_1.Job, (job) => job.emails),
    (0, typeorm_1.JoinTable)({ name: 'email_job' }),
    __metadata("design:type", Array)
], Email.prototype, "jobs", void 0);
__decorate([
    (0, typeorm_1.ManyToMany)(() => contact_1.Contact, (contact) => contact.emails),
    (0, typeorm_1.JoinTable)({ name: 'email_contact' }),
    __metadata("design:type", Array)
], Email.prototype, "contacts", void 0);
__decorate([
    (0, typeorm_1.ManyToMany)(() => accounting_documents_1.AccountingDocument, (accountingDocument) => accountingDocument.emails),
    (0, typeorm_1.JoinTable)({ name: 'email_accounting_document' }),
    __metadata("design:type", Array)
], Email.prototype, "accountingDocuments", void 0);
Email = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
    }),
    data_ui_1.DataUi.Name({
        name: 'Email',
        nameProperties: ['subject'],
    }),
    data_ui_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Entity)('email', {
        schema: 'public',
    })
], Email);
exports.Email = Email;
//# sourceMappingURL=email.js.map